import React, { FC } from 'react';
import ModalWrapper from '@components/modal/ModalWrapper';
import { ColorFunction } from '@styles/colors/types';
import { View } from 'react-native';
import { scale } from '@components/frame';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';
import ActionMenu from '@components/common/actionMenu';
import { ActionMenuConfigItem, ContainerStyle } from '@interfaces/base';

export interface ChooseCropModeModalProps extends ContainerStyle {
  isVisible: boolean;
  C: ColorFunction;
  onClose: () => void;
  config: ActionMenuConfigItem[];
}

const ChooseCropModeModal: FC<ChooseCropModeModalProps> = ({ C, isVisible, onClose, containerStyle, config }: ChooseCropModeModalProps) => {
  return (
    <ModalWrapper isVisible={isVisible} C={C} onBackdropPress={onClose}>
      <View
        style={[
          {
            position: 'absolute',
            alignItems: 'flex-end',
          },
          containerStyle,
        ]}
      >
        <View
          style={{
            backgroundColor: C('Background/Light/Modal'),
            borderRadius: scale(SCREEN_BORDER_RADIUS),
          }}
        >
          <ActionMenu {...{ C, items: config, borderRadius: scale(SCREEN_BORDER_RADIUS), bg: 'Background/Light/Field on Panel', scale }} />
        </View>
      </View>
    </ModalWrapper>
  );
};

export default ChooseCropModeModal;
